<template>
  <li class="speaker-section__list__question">{{ text }}</li>
</template>
<script>
  export default {
    name: 'UXFolderQuestion',
    props: {
      text: String
    }
  }
</script>

